module.exports = __webpack_public_path__ + "static/media/eye-solid.5cab55a7.svg";